let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

subscribe(PUB_SUB_EVENTS.cartUpdate, (response) => {
  if (!response.cartData) return;
  const cart = response.cartData;

  window.dataLayer.push({
    event: "ga4_add_to_cart",
    ...GENERAL_ATTRIBUTES,
    product_variant_id: cart.variant_id,
    product_sku: cart.sku,
    content_ids: cart.product_id,
    content_name: cart.product_title,
    content_type: "product",
    quantity: cart.quantity,
    item_price: cart.price / 100,
  });
});
